import script from "./EditShopProductGroupDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditShopProductGroupDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditShopProductGroupDialog.vue?vue&type=style&index=0&id=1d257528&lang=css"
import "./EditShopProductGroupDialog.vue?vue&type=style&index=1&id=1d257528&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d257528"]])

export default __exports__